import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c97ba14"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aan de woning zijn de volgende onvolkomenheden geconstateerd:", -1))
const _hoisted_2 = {
  key: 0,
  class: "room-name"
}
const _hoisted_3 = { class: "issue" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { deliveryStore } from '@/stores/delivery'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionFooterCard',
  setup(__props) {

const issuesFound = computed(() => {
  let issuesFound = false

  deliveryStore().delivery.rooms.forEach((r:{ survey_form: { chapters: { questions: { answer: { issues: { id:number }[] } }[] }[] }}) => {
    r.survey_form.chapters.forEach((c) => {
      c.questions.forEach((q) => {
        if (q.answer.issues.length) {
          issuesFound = true
        }
      })
    })
  })

  return issuesFound
})

const allRequiredAnswered = computed(() => {
  const allRequiredAnswered:boolean[] = []

  deliveryStore().delivery.rooms.forEach((r:{ survey_form: { chapters: { questions: { required:boolean, answer: { answer:string|null, issues: { id:number }[] } }[] }[] }}, index:number) => {
    allRequiredAnswered[index] = true
    r.survey_form.chapters.forEach((c) => {
      c.questions.forEach((q) => {
        if (q.required && q.answer.answer === null) {
          allRequiredAnswered[index] = false
        }
      })
    })
  })

  return allRequiredAnswered
})

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Samenvatting en bevestigen",
    bordered: false
  }, {
    default: _withCtx(() => [
      (_unref(issuesFound))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryStore)().delivery.rooms, (r) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: r.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.survey_form.chapters, (c) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: c.id
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.questions, (q) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: q.id
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(q.answer.issues, (i, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: i.id
                          }, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                  _createElementVNode("b", null, _toDisplayString(r.level) + "." + _toDisplayString(r.position) + " " + _toDisplayString(r.name) + " - " + _toDisplayString(q.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_3, "#" + _toDisplayString(i.id) + " - " + _toDisplayString(i.description), 1)
                          ], 64))
                        }), 128))
                      ], 64))
                    }), 128))
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Geen onvolkomenheden geconstateerd aan de woning.")),
      _createVNode(_component_a_divider),
      _createElementVNode("p", null, [
        _createTextVNode("Opgemaakt te "),
        _createElementVNode("b", null, _toDisplayString(_unref(deliveryStore)().delivery.building.city), 1),
        _createTextVNode(" op "),
        _createElementVNode("b", null, _toDisplayString(new Date().toLocaleDateString('nl-NL')), 1),
        _createTextVNode(".")
      ]),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_unref(deliveryStore)().delivery.inspection_scheduled_user?.full_name), 1),
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_unref(deliveryStore)().delivery.inspection_scheduled_user?.company?.name), 1)
      ]),
      _createVNode(_component_a_divider),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: _unref(deliveryStore)().loading.saving,
        disabled: !_unref(allRequiredAnswered) || _unref(deliveryStore)().loading.saving,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(deliveryStore)().completeInspection()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Voorschouw definitief opslaan")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})